export default {
  meta: {
    title: '日报详情',
    url: '/abside/dailydetail',
    urlName: 'ab侧-日报详情',
    logincallback: '/abside',
  },
};
